import React from 'react';
import { WrapLayer } from '../styles';

const Layer = (props: any) => {
  const { handleClose, onClick } = props;
  return <WrapLayer onClick={onClick || handleClose} />;
};

export default Layer;
